<div>
    <!-- Main section -->

    <div class="accordion" id="PILoopAccordian">
        <div class="card" id="profileLoopAccDiv"
        *ngFor="let attractorLoop of displayAttractorLoop | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
        <div class="card-header small_text" id="loopOne">
                <div class="cp_acc_check" id="profileLoopAccCheck">
                    <div class="form-check" id="profileLoopAccFrmCheck">
                        <input type="checkbox" name="attLoopSelect" class="form-check-input checkboxCSS" [checked]="attractorLoop.checked" (change)="getSelectedAttractLoopChkBx($event,attractorLoop.id,attractorLoop.index)" />
                    </div>
                </div>
                <div class="card-header-content" id="cardHeaderContentDiv">
                    
                    <div class="title_left" id="titleLeftDiv">
                        <div class="title" id="titleDiv">
                            <span>{{attractorLoop?.configurations?.publishedName}} &nbsp;&nbsp;</span>
                        </div>
                        <div *ngIf="(attractorLoop.isContentExpires)" id="contentExpire" class="d-flex"><img class="contents-info-icon" alt="info_icon"><span>{{globalConstant.CONT_GRP_EXPIRED_TEXT}}</span></div>
                    </div>
                    <div class="other_data" id="otherDataDiv">
                        <div class="subtitle_group" id="subTitleGroupDiv">
                            <span class="subtitle"><span i18n="@@profile-attractor-loop.last-edit-by-label">Last Edited By</span> {{attractorLoop?.createdByUser}}:
                                {{attractorLoop?.updateTime | dateFormat: "changeToLocalTimeZone"}}                                
                            </span>
                        </div>
                    </div>
                </div>

                <div id="collapseLinkDiv" class="collapse_link collapsed"   [attr.aria-expanded]="attractorLoop?.isExpanded"
                
                 (click)="getDetailsOfAttractorLoop(attractorLoop?.id)" type="button"
                    >
                    <svg  [ngClass]="attractorLoop.isExpanded ? 'transform-180' : 'cursor-pointer'" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M2.469 6.96936C2.53867 6.89952 2.62143 6.8441 2.71255 6.80629C2.80367 6.76849 2.90135 6.74902 3 6.74902C3.09865 6.74902 3.19633 6.76849 3.28745 6.80629C3.37857 6.8441 3.46133 6.89952 3.531 6.96936L12 15.4399L20.469 6.96936C20.5387 6.89963 20.6215 6.84432 20.7126 6.80658C20.8037 6.76884 20.9014 6.74942 21 6.74942C21.0986 6.74942 21.1963 6.76884 21.2874 6.80658C21.3785 6.84432 21.4613 6.89963 21.531 6.96936C21.6007 7.0391 21.656 7.12188 21.6938 7.21299C21.7315 7.3041 21.7509 7.40175 21.7509 7.50036C21.7509 7.59898 21.7315 7.69663 21.6938 7.78774C21.656 7.87885 21.6007 7.96163 21.531 8.03136L12.531 17.0314C12.4613 17.1012 12.3786 17.1566 12.2874 17.1944C12.1963 17.2322 12.0986 17.2517 12 17.2517C11.9013 17.2517 11.8037 17.2322 11.7125 17.1944C11.6214 17.1566 11.5387 17.1012 11.469 17.0314L2.469 8.03136C2.39915 7.9617 2.34374 7.87893 2.30593 7.78781C2.26812 7.6967 2.24866 7.59901 2.24866 7.50036C2.24866 7.40171 2.26812 7.30403 2.30593 7.21291C2.34374 7.1218 2.39915 7.03903 2.469 6.96936Z" />
                    </svg>
                </div>
            </div>
            <div id="collapseLoopOne" #collapse="ngbCollapse" [(ngbCollapse)]="!attractorLoop.isExpanded" aria-labelledby="loopOne" 
            data-parent="#PILoopAccordian">
                <div class="card-body" id="collapseCardBody">
                    <div id="collapseLoopCardDiv">
                        <div class="row" id="collapseLoopRow">
                        <!-- Video part Start -->
                            <div class="col-md-3" id="collapseColMd3Div">
                                <div class="preview_attract" id="preiviewAttractDiv">
                                <div class="main_heading_attract_preview"scope="col" id="mainAttractPreview"><span i18n="@@profile-attractor-loop.upload-video-label" class="font-weight-bold">Uploaded Video</span></div>
                                <div id="uploadVideoNameDiv"><span>{{attractorLoop?.configurations?.uploadedVideoName}}</span></div>
                                <div class="mini-preview-container" id="miniPreviewContainer">
                                    <div class="each-mini-preview" id="eachMiniPreviewDiv">
                                        <iposcen-live-preview [data]="loadMiniPreview(attractorLoop.id)">
                                        </iposcen-live-preview>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <!-- IIT2-4663-->                            
                            <div id="attractPublishExpireTime" class="column col-md-4" *ngIf="attractorLoop?.configurations?.publishTime && attractorLoop?.configurations?.expireTime">
                                <div class="pb-4" id="publishDataAndTime">
                                  <span i18n="@@price-content.group-tab.publish-date-time" class="font-weight-bold">Publishing Date and
                                  Time</span>
                                  <div id="publishTimeFormatDiv">{{attractorLoop?.configurations?.publishTime | dateFormat: "24hrP"}}</div>
                                </div>
                                <div>
                                  <span i18n="@@price-content.group-tab.expiration-date-time" class="font-weight-bold" id="expirationDateAndTime">Expiration Date
                                    and Time</span>
                                  <div id="expireTimeDiv">{{attractorLoop?.configurations?.expireTime | dateFormat: "24hrP"}}</div>
                                </div>
                            </div>
                            <!-- IIT2-4663-->
                            <div class="col-md-5" id="previewAttractDiv1">
                            <div class="preview_attract" id="previewAttractDiv2">
                            <div class="main_heading_attract_preview" scope="col" id="mainHeadingAttractPreviewContentGroupAppliesDiv"><span i18n="@@banner-carousel.content-group-applies-to" class="font-weight-bold">Content Group
                                    Applies
                            To</span>: </div>
                            <div id="frmFactorDeviceType"><strong><span>{{ globalConstant.DEVICE_TYPES }}</span>: </strong>
                                {{ attractorLoop?.configurations?.formFactor?.devices.length ? attractorLoop?.configurations?.formFactor?.devices : globalConstant.ALL}}
                            </div>
                            <div id="frmFactorManufacturer"><strong><span>{{ globalConstant.MANUFACTURERS }}</span>:</strong>
                             {{ attractorLoop?.configurations?.formFactor?.manufacturer.length ?
                             attractorLoop?.configurations?.formFactor?.manufacturer : globalConstant.ALL}}
                            </div>
                            <div id="frmFactorProcessors"><strong><span>{{ globalConstant.PROCESSORS }}</span>: </strong>
                            {{ attractorLoop?.configurations?.formFactor?.processors.length ? attractorLoop?.configurations?.formFactor?.processors :
                            globalConstant.ALL}}
                            </div>
                            <div id="frmFactorGenerations"><strong><span>{{ globalConstant.GENERATIONS }}</span>:</strong>
                            {{ attractorLoop?.configurations?.formFactor?.generations.length ? attractorLoop?.configurations?.formFactor?.generations :
                            globalConstant.ALL}}
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Data Footer - Pagination -->
    <div class="data_footer" id="dataFooterDiv">
        <nav aria-label="attractor loop content pagination" *ngIf="displayAttractorLoop?.length > 0">
            <ngb-pagination [collectionSize]="displayAttractorLoop?.length" [(page)]="page"
                [pageSize]="pageSize" [rotate]="true" [ellipses]="false" [boundaryLinks]="false">
            </ngb-pagination>
        </nav>
    </div>
</div>